import React, { useState, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import {
  getFirestore,
  collection,
  addDoc,
  serverTimestamp,
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBALO-oNqvxmRhTSx9S54A5PIilTrxVOYM",
  authDomain: "refinery-desk-dashboard.firebaseapp.com",
  projectId: "refinery-desk-dashboard",
  storageBucket: "refinery-desk-dashboard.firebasestorage.app",
  messagingSenderId: "28035012838",
  appId: "1:28035012838:web:eb80f171a10371cdbec327"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default function ItemShortcut({ userId, selectedCustomer, onBack }) {
  const title = 'Refinery Branch Shortcut';

  const cards = [
    {
      title: 'PHETCHABURI THONGLOR',
      subtitle: 'ติดถนนเพชรบุรีตัดใหม่ หยุดทุกวันจันทร์\nเปิด 11:00 - 20:00 น.',
      imageUrl:
        'https://firebasestorage.googleapis.com/v0/b/refinery-desk-dashboard.firebasestorage.app/o/refinery-asset%2Fitem-shortcut%2F1669997734500-2jf3toEKlpqQleQik2NXxA47s85JQx0XnjAE0Oznu7ZchiSQui.jpg?alt=media',
      buttonLabel: 'ค้นหาเส้นทาง',
      buttonLink: 'https://rfn.clinic/w-thonglormaps',
      caption: 'รายละเอียด Location คลินิกค่ะ\n\nhttps://goo.gl/maps/jdA7S5PrrM2XL2iv5\n\nหากเดินทางโดยรถยนต์\nตัวคลินิกติดถนนเพชรบุรีตัดใหม่ มีที่จอดรถให้บริการฟรี\nจุดสังเกต: ทางเข้าติดกับธนาคารไทยพาณิชย์\n\nเดินทางด้วยรถไฟฟ้า\n– MRT สถานีเพชรบุรี ทางออก 1\n– BTS สถานีทองหล่อ ทางออก 3\nต่อวินมอเตอร์ไซค์ หรือแอปพลิเคชัน มายัง TCM หรือ Carpet Inter',
    },
  ];

  const [successMessage, setSuccessMessage] = useState('');
  const [confirmIndex, setConfirmIndex] = useState(null);

  const scrollRef = useRef(null);

  const getScrollableParent = (el) => {
    let node = el;
    while (node && node !== document.body) {
      const { overflowY } = window.getComputedStyle(node);
      if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
        return node; // เจอคอนเทนเนอร์ที่เลื่อนได้จริง
      }
      node = node.parentElement;
    }
    return window; // ถ้าไม่เจอ ให้เลื่อนทั้งหน้าต่าง
  };

  const scrollToTop = () => {
    const target = getScrollableParent(scrollRef.current);
    if (target === window) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      target.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const sendToLineFlex = async (card) => {
    const flexMessage = {
      type: 'flex',
      altText: card.title,
      contents: {
        type: 'bubble',
        hero: {
          type: 'image',
          url: card.imageUrl,
          size: 'full',
          aspectRatio: '16:10',
          aspectMode: 'cover',
        },
        body: {
          type: 'box',
          layout: 'vertical',
          spacing: 'sm',
          contents: [
            {
              type: 'text',
              text: card.title,
              weight: 'bold',
              size: 'lg',
              wrap: true,
            },
            {
              type: 'text',
              text: card.subtitle,
              size: 'sm',
              color: '#555555',
              wrap: true,
            },
          ],
        },
        footer: {
          type: 'box',
          layout: 'vertical',
          spacing: 'sm',
          contents: [
            {
              type: 'button',
              style: 'link',
              height: 'sm',
              action: {
                type: 'uri',
                label: card.buttonLabel,
                uri: card.buttonLink,
              },
            },
          ],
          flex: 0,
        },
      },
    };

    const res = await fetch('https://therefineryclinic.herokuapp.com/sendFlexMessage', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, flexMessage }),
    });

    const result = await res.json();
    if (!result.success) throw new Error(result.error || 'ส่ง LINE ไม่สำเร็จ');

    const latestCustomerInfo = selectedCustomer || {};
    await addDoc(collection(db, 'messages'), {
      from: 'me',
      role: 'me',
      userId,
      type: 'text',
      customer: `[CARD] ${card.title}`,
      createdAt: serverTimestamp(),
      displayName: latestCustomerInfo.displayName || 'Customer',
      pictureUrl: latestCustomerInfo.pictureUrl || '',
    });
  };

  const sendWithCaption = async (card) => {
    try {
      await sendToLineFlex(card);

      if (card.caption) {
        await fetch('https://therefineryclinic.herokuapp.com/sendToLine', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ userId, message: card.caption }),
        });

        const latestCustomerInfo = selectedCustomer || {};
        await addDoc(collection(db, 'messages'), {
          from: 'me',
          role: 'me',
          userId,
          type: 'text',
          customer: card.caption,
          createdAt: serverTimestamp(),
          displayName: latestCustomerInfo.displayName || 'Customer',
          pictureUrl: latestCustomerInfo.pictureUrl || '',
        });
      }

      setSuccessMessage(`"${card.title}" card with caption has been sent successfully`);
      setTimeout(() => setSuccessMessage(''), 1800);
    } catch (err) {
      console.error('❌ LINE ERROR:', err);
      alert('❌ ไม่สามารถส่งการ์ด + ข้อความได้');
    }
  };

  return (
    <div ref={scrollRef} className="relative max-w-screen-xl mx-auto">
      <div className="flex items-center gap-3 mt-[-2px] mb-4 w-full">
        <div className="flex items-center gap-3">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button
            onClick={onBack}
            className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 bg-gray-100 hover:bg-gray-200 transition"
          >
            ← Back
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full max-w-6xl">
        {cards.map((card, index) => (
          <div key={index} className="flex flex-col items-start gap-4">
            <div
              className="rounded-[1.0625em] overflow-hidden shadow-md bg-white flex flex-col items-center"
              style={{ width: '16em' }}
            >
              <div className="w-full aspect-[16/10] relative">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>

              <div className="p-4 space-y-2 w-full">
                <h2 className="text-[1.375em] font-bold text-gray-800 leading-tight">
                  {card.title}
                </h2>
                <p className="text-[0.875em] text-gray-600 whitespace-pre-line leading-snug">
                  {card.subtitle}
                </p>
              </div>

              <div className="px-4 pb-4 w-full text-center space-y-3">
                <a
                  href={card.buttonLink}
                  className="text-[0.875em] text-blue-600 hover:underline font-medium block"
                  target="_blank"
                  rel="noreferrer"
                >
                  {card.buttonLabel}
                </a>
                <button
                  onClick={() => setConfirmIndex(index)}
                  className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-4 py-1.5 rounded-full shadow-sm w-full"
                >
                  Send Card
                </button>
                <button
                  onClick={() => sendWithCaption(card)}
                  className="bg-black hover:opacity-80 text-white text-sm font-semibold px-4 py-1.5 rounded-full shadow-sm w-full"
                >
                  + Caption
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {confirmIndex !== null && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-xl max-w-sm w-full px-6 py-5 text-center">
            <p className="text-sm text-gray-800 mb-5 whitespace-pre-line">
              Confirm sending the <b>{cards[confirmIndex].title}</b> card to the customer?
            </p>
            <div className="flex justify-center gap-3">
              <button
                onClick={() => {
                  sendToLineFlex(cards[confirmIndex]);
                  setConfirmIndex(null);
                }}
                className="px-4 py-1 text-sm text-white bg-black rounded-full"
              >
                Send
              </button>
              <button
                onClick={() => setConfirmIndex(null)}
                className="px-4 py-1 text-sm text-gray-600 border border-gray-300 rounded-full hover:bg-gray-100"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {successMessage && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="bg-white shadow-xl rounded-xl px-6 py-4 border border-gray-200 text-center max-w-sm w-full">
            <div className="text-sm text-gray-800 mb-3 whitespace-pre-line">{successMessage}</div>
            <button
              onClick={() => setSuccessMessage('')}
              className="text-xs px-3 py-1 border border-gray-300 rounded-full hover:bg-gray-100 transition text-gray-500"
            >
              Close
            </button>
          </div>
        </div>
      )}

      <div className="mt-6 flex justify-between items-center">
        {/* ปุ่ม Back ล่างซ้าย */}
        <button
          onClick={onBack}
          className="px-2 py-1 text-xs rounded-full border border-gray-300 
             text-gray-500 bg-gray-100 hover:bg-gray-200 transition"
        >
          ← Back
        </button>

        {/* ปุ่ม Top ล่างขวา */}
        <button
          onClick={scrollToTop}
          className="px-2 py-1 text-xs rounded-full border border-gray-300 
             text-gray-500 bg-gray-100 hover:bg-gray-200 transition"
        >
          ↑ Top
        </button>
      </div>

    </div>
  );
}
